import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card, F0TagStatus } from '@factorialco/f0-react'
import {
  ContractHistoryContractPeriodFragment,
  ContractHistoryContractVersionHistoryFragment,
  ContractsValueObjectsContractScheduleEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CreatedBy from 'modules/contracts/components/NewContractHistory/ContractVersionCard/CreatedBy'
import { getPeriodTime, getPeriodTimeWithSince } from 'modules/contracts/lib/ContractHistoryUtils'
import { useRoute } from 'modules/contracts/pages/ContractVersionsPage/_RouteContext'

interface Props {
  period: ContractHistoryContractPeriodFragment
  status: ContractsValueObjectsContractScheduleEnum
  selectedContractVersionId: string | undefined
  version?: ContractHistoryContractVersionHistoryFragment
  onContractVersionSelect?: (referenceVersionId: string | undefined) => void
  contractOngoingActivityPeriodId?: string
}

const PeriodCard = ({
  period,
  status,
  version,
  selectedContractVersionId,
  onContractVersionSelect,
  contractOngoingActivityPeriodId,
}: Props) => {
  const route = useRoute()
  const isUpcoming = status === 'upcoming'
  const isSelected = selectedContractVersionId
    ? period.contractVersionId === selectedContractVersionId
    : false

  const type =
    period.type === 'activity'
      ? i18n.t('contract_versions.navigator.history.periods.activity')
      : i18n.t('contract_versions.navigator.history.periods.inactivity')

  const actionLabel = isSelected
    ? i18n.t('contract_versions.navigator.history.back_to_current_conditions')
    : i18n.t('contract_versions.navigator.history.see_future_conditions')

  const showCardAction = period.type === 'activity' && isUpcoming

  const onContractVersionSelected = () => {
    const referenceVersionId = isSelected
      ? contractOngoingActivityPeriodId || period.contractVersionId
      : period.contractVersionId

    if (!referenceVersionId) return

    window.history.replaceState(null, 'Factorial', route.contractVersionPath(referenceVersionId))
    onContractVersionSelect?.(referenceVersionId)
  }

  return (
    <Box position="relative">
      <F0Card
        title={type}
        description={getPeriodTimeWithSince(period)}
        {...(showCardAction && {
          secondaryActions: [
            {
              label: actionLabel,
              onClick: onContractVersionSelected,
            },
          ],
        })}
      >
        <Box gap="s12">
          {getPeriodTime(period) && (
            <Box flexDirection="row" gap="s12">
              <Box flexDirection="row" gap="s4" alignItems="center" width="s200">
                <Text.Normal size="200" weight="normal" color="grey800">
                  {i18n.t('contract_versions.navigator.history.duration_period')}
                </Text.Normal>
              </Box>
              <Box flexDirection="row" gap="s4" alignItems="center" width="s200">
                <Text.Normal size="200" weight="medium" color="grey1000">
                  {getPeriodTime(period)}
                </Text.Normal>
              </Box>
            </Box>
          )}
          {version && <CreatedBy version={version} />}
        </Box>
      </F0Card>
      <Box position="absolute" style={{ top: '16px', right: '16px' }} flexDirection="row" gap="s8">
        {isUpcoming && (
          <F0TagStatus
            text={i18n.t('contract_versions.navigator.history.status_tag.upcoming')}
            variant={'warning'}
          />
        )}
      </Box>
    </Box>
  )
}

export default PeriodCard
